import React, { useEffect, useId, useState } from 'react';
import { searchUnlocodes } from '../services/unlocodeService';

const MIN_QUERY_LENGTH = 2;
const SEARCH_DELAY_MS = 200;

export default function LocationAutocompleteInput({
  name,
  value = '',
  onChange,
  placeholder,
  id,
  className,
  disabled = false,
  required = false,
  autoFocus = false,
  type,
  ...rest
}) {
  const generatedId = useId();
  const inputId = id || `${name || 'location'}-${generatedId}`;
  const listId = `${inputId}-unlocode-list`;

  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    const query = String(value || '').trim();
    if (query.length < MIN_QUERY_LENGTH || disabled) {
      setSuggestions([]);
      return;
    }

    let ignore = false;
    const handle = setTimeout(() => {
      searchUnlocodes(query, 12)
        .then(results => {
          if (!ignore) {
            setSuggestions(results);
          }
        })
        .catch(error => {
          if (!ignore) {
            console.error('No se pudieron cargar sugerencias UNLOCODE', error);
            setSuggestions([]);
          }
        });
    }, SEARCH_DELAY_MS);

    return () => {
      ignore = true;
      clearTimeout(handle);
    };
  }, [value, disabled]);

  return (
    <>
      <input
        {...rest}
        id={inputId}
        name={name}
        type={type || 'search'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={className}
        list={listId}
        autoComplete="off"
        spellCheck="false"
        disabled={disabled}
        required={required}
        autoFocus={autoFocus}
        inputMode="search"
      />
      <datalist id={listId}>
        {suggestions.map(option => (
          <option key={`${option.locode}-${option.display}`} value={option.display} />
        ))}
      </datalist>
    </>
  );
}
